import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  body.dark & {
    --success-payment-next-actions-border-bottom: 1px solid #331e31;
  }

  --success-payment-next-actions-border-bottom: 1px solid #fff;
  padding: 20px 0 0;

  ion-content {
    position: relative;
  }
`;
